export default __webpack_public_path__ + "scenes26707b3.png";